var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{staticClass:"iconfont",class:_vm.name,style:(_vm.getStyle),on:{"click":function($event){$event.stopPropagation();return _vm.onCilck()}}})
}
var staticRenderFns = []

export { render, staticRenderFns }